import { useEffect, useRef } from "react";
import React from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useDispatch, useSelector } from "react-redux";
import { toWebp } from "../../utils/common";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

import "@splidejs/react-splide/css";
import "@splidejs/react-splide/css/core";
import Image from "next/image";

let baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

const LogosSlider = () => {
	const swiperRefLocal = useRef();
	const dispatch = useDispatch();
	const commonData = useSelector((state) => state.sliderReducer.commonData);
	const sliderData = useSelector((state) => state.sliderReducer.sliderData);

	useEffect(() => {
		if (commonData.trusted_by_slider) {
			dispatch({
				type: "SET_SLIDER_DATA",
				payload: {
					images: commonData.trusted_by_slider?.images,
					title: commonData.trusted_by_slider?.title,
				},
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [commonData]);
	return (
		<section className="partner-logo-section section-pad-0 bg-two" style={{ minHeight: '120px' }}>
			{sliderData?.images?.length ? (
				<div className="partner-logo-inner">
					<div className="container">
						<div className="row align-items-center">
							<div className="col-lg-2">
								<div className="partner-logo-title">
									<p className="font-medium text-light-black">{sliderData?.title}</p>
								</div>
							</div>
							<div className="col-lg-10">
								<div className="partner-logo-slider">
									<Splide
										className="partner-logo"
										ref={swiperRefLocal}
										extensions={{ AutoScroll }}
										options={{
											arrows: false,
											pagination: false,
											autoWidth: true,
											type: "loop",
											drag: "free",
											focus: "center",
											autoScroll: {
												rewind: false,
												speed: 1,
											},
										}}
									>
										{sliderData?.images?.map(
											(logo, index) => (
												<SplideSlide key={index}>
													<div className="partner-logo-item">
														<div className="partner-logo-img">
															<Image
																src={toWebp(
																	`${baseUrl}${logo?.image?.url}`
																)}
																alt={
																	logo?.image
																		?.alternativeText ||
																	logo?.image
																		?.name
																}
																width={150}
																height={40}
																loading="eager"
																quality={75}
															/>
														</div>
													</div>
												</SplideSlide>
											)
										)}
									</Splide>
								</div>
							</div>
						</div>
					</div>
				</div>
			) : null}
		</section>
	);
};

export default LogosSlider;

